module.exports = __webpack_public_path__ + "img/icon-clients.88aab526.svg";